import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/31c62e42039e6e289d97944d8b0d7aa6/77cdc51489c74956193760ddc20e31c5.jpeg"
              alt="Sorto's Premier Roofing"
              className="w-12 h-12 object-contain"
            />
            <div>
              <h1 className={`text-lg font-bold ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Sorto's Premier Roofing
              </h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-500'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('free-inspection')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-500'
              }`}
            >
              Free Inspection
            </button>
            <button
              onClick={() => scrollToSection('warranty')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-500'
              }`}
            >
              Warranty
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-500'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-500'
              }`}
            >
              Contact
            </button>
            <a
              href="tel:4172295037"
              className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-full transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              Call Now
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col gap-2 p-4">
              <button
                onClick={() => scrollToSection('services')}
                className="text-left py-3 px-4 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('free-inspection')}
                className="text-left py-3 px-4 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Free Inspection
              </button>
              <button
                onClick={() => scrollToSection('warranty')}
                className="text-left py-3 px-4 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Warranty
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left py-3 px-4 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left py-3 px-4 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
              <a
                href="tel:4172295037"
                className="mt-2 py-3 px-4 bg-orange-500 text-white text-center font-semibold rounded-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call Now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
